import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SeriesCodeGenerator  {
    _originalTypeClassName = "zERP.BO.SeriesCodeGenerator";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SeriesCodeGenerator.translate = translateService;
}
this.SeriesCodeGeneratorKey = null;
this._key = this.SeriesCodeGeneratorKey = 0; 
}

static translate: TranslateService;
_key: any;
private _SeriesCodeGeneratorKey:any;
get SeriesCodeGeneratorKey(): any {
    return this._SeriesCodeGeneratorKey;
  }
set SeriesCodeGeneratorKey(value: any) {
    this._SeriesCodeGeneratorKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.SeriesCodeGeneratorKey == null || $this.SeriesCodeGeneratorKey == 0;
            }


}